/**
 * BayCard Component
 * 
 * Displays an individual bay with image, name, status, and selection state.
 * Uses native button with accessible states for keyboard navigation.
 */

import { getBayImageUrl } from '#utils';
import { CheckmarkIcon } from '#icons';
import type { BayCardProps } from './types';

export function BayCard({ bay, isSelected, onSelect, disabled, index = 0, showAllBays = false }: BayCardProps) {
  const isDisabled = disabled || (!showAllBays && !bay.isAvailable);
  
  return (
    <button
      type="button"
      onClick={() => !isDisabled && onSelect(bay.id)}
      disabled={isDisabled}
      aria-label={`${bay.name}${isDisabled ? ' (unavailable)' : isSelected ? ' (selected)' : ''}`}
      aria-pressed={isSelected}
      className="bay-card group relative flex flex-col disabled:opacity-60"
      data-testid={`booking-bay-card-${bay.name}`}
    >
      {/* Bay Image Container */}
      <div className={`relative w-64 overflow-hidden rounded-28 ${
        isSelected ? 'ring-4 ring-theme-600' : ''
      }`}>
        <img
          src={getBayImageUrl(bay, index)}
          alt={bay.image?.alt || `${bay.name} simulator bay`}
          className="h-80 w-full object-cover"
          loading="lazy"
        />
        
        {/* Selected Indicator - White circle with black checkmark */}
        {isSelected && (
          <div className="absolute right-3 top-3 rounded-full bg-white p-2 shadow-sm">
            <CheckmarkIcon className="size-4 text-black" ariaHidden />
          </div>
        )}
        
        {/* Status Badge */}
        {/* {!bay.isAvailable && (
          <div className="absolute bottom-3 left-3 rounded-lg bg-black/75 px-3 py-1.5 text-xs font-medium text-white">
            {bay.statusMessage}
          </div>
        )} */}
        
        {/* Chips (Prime Time, etc.) */}
        {/* {bay.chips.length > 0 && bay.isAvailable && (
          <div className="absolute right-3 top-3 flex flex-col gap-2">
            {bay.chips.map((chip) => (
              <span
                key={chip}
                className="rounded-lg bg-yellow-400 px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm"
              >
                {chip}
              </span>
            ))}
          </div>
        )} */}
      </div>
      
      {/* Bay Name - Figma: weight 500, size 22px, color fg-primary */}
      <div className="flex flex-col items-start gap-1 pt-2">
        <h3 className="text-lg font-medium text-butter-gray-800">{bay.name}</h3>
      </div>
    </button>
  );
}
